import { Avatar, Flex, Text } from '@chakra-ui/react';
import DavidRollins from '../images/davidRollins.png';
import JoeWells from '../images/joeWells.png';
import JoshAnderson from '../images/joshAnderson.png';

interface Testimonial {
	name: string;
	position: string;
	testimonial: string;
	photo: string;
}

/**
 * The Testimonials section
 * @returns The Testimonials Component
 */
export default function Testimonials() {

	// User Testimonials
	const testimonials = [
		{
			name: "David Rollins",
			position: "CEO, Aura Ad Co.",
			testimonial: "Working with John was an experience nothing short of exceptional. From the design stages through deliverables, John not only executed the product vision, but took a keen interest in understanding the product itself, which made for a better UI and UX. John is artistic, technical, and most importantly, flexible. If you're considering working with John, do it!",
			photo: DavidRollins
		},
		{
			name: "Joe Wells",
			position: "Attorney, Outlaw Defense",
			testimonial: "I had the pleasure of working with John on my website for my criminal defense practice. His ability to translate my requirements into a sleek website exceeded my expectations.",
			photo: JoeWells
		},
		{
			name: "Josh Anderson",
			position: "CEO, Cantaloupe",
			testimonial: "John is a great communicator. I always felt like he communicated clearly when I worked with him, even when collaborating on a complicated project with many moving parts.",
			photo: JoshAnderson
		},
	];

	return (
		<Flex
			direction={{ base: "column", md: "row" }}
			align="stretch"
			width={{ base: "85%", md: "100%" }}
			padding="0"
			margin={"auto"}
		>
			{/* Testimonial 1 */}
			<Flex
				direction="column"
				backgroundColor="blue.500"
				width={{ base: "100%", md: "50%" }}
				padding="30px"
				gap={5}
				boxSizing="border-box"
        		flex={{ base: 'none', md: '1' }}
			>
				<Header testimonial={testimonials[0]} />
				<Text
					fontFamily="Source Code Pro Variable"
					fontWeight="400"
					fontSize="lg"
					color="whiteAlpha.800"
				>
					"{testimonials[0].testimonial}"
				</Text>
			</Flex>

			{/* Testimonial 2 & 3 */}
			<Flex
				direction="column"
				width={{ base: "100%", md: "50%" }}
				overflow="hidden"
				gap={0}
			>
				{testimonials.slice(1).map((testimonial, index) => (
				<Flex
					key={index}
					direction="column"
					backgroundColor={index === 0 ? "blue.100" : "green.100"}
					width="100%"
					padding="30px"
					gap={5}
					boxSizing="border-box"
					flex={{ base: 'none', md: '1' }}
				>
					<Header testimonial={testimonial} />
					<Text
						fontFamily="Source Code Pro Variable"
						fontWeight="400"
						fontSize="lg"
						color="whiteAlpha.800"
					>
						"{testimonial.testimonial}"
					</Text>
				</Flex>
				))}
			</Flex>
		</Flex>
	);
};

function Header({ testimonial }: { testimonial: Testimonial }) {
	return (
		<Flex
			width="100%"
			direction="row"
			wrap="wrap"
			justifyContent="center"
			gap={5}
		>
		<Avatar
			size="xl"
			name={testimonial.name}
			src={testimonial.photo}
			border="3px solid white"
		/>
		<Flex
			direction="column"
			justifyContent="center"
			textAlign="center"
		>
			<Text
				fontFamily="Source Code Pro Variable"
				fontWeight="600"
				fontSize="xl"
				color="whiteAlpha.800"
			>
				{testimonial.name}
			</Text>
			<Text
				fontFamily="Source Code Pro Variable"
				fontWeight="500"
				fontSize="lg"
				color="whiteAlpha.800"
			>
				{testimonial.position}
			</Text>
		</Flex>
		</Flex>
	);
}
